import React from 'react';
import ProjecaoMensalTab from '../components/ProjecaoMensalTab';

export default function ProjecaoPage() {
  return (
    <div className="animate-in fade-in duration-300">
      <ProjecaoMensalTab />
    </div>
  );
}
